import { color, font } from './tokens';
import { Button, Group } from '@mantine/core';
import { useState } from 'react';

/**
 * Recovery codes as the server returned them, shown once. Copy and download
 * hand them to the user; nothing keeps them after this component unmounts.
 */
export function RecoveryCodeList({ codes, dark = false }: { codes: string[]; dark?: boolean }) {
  const [copied, setCopied] = useState(false);
  const text = codes.join('\n') + '\n';

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  const download = () => {
    const url = URL.createObjectURL(new Blob([text], { type: 'text/plain' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = 'goatms-central-recovery-codes.txt';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <ol
        aria-label="Recovery codes"
        style={{
          margin: 0,
          padding: '12px 16px',
          listStyle: 'none',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))',
          gap: '6px 16px',
          fontFamily: font.mono,
          fontSize: 14,
          borderRadius: 8,
          background: dark ? color.signInPage : color.page,
          border: `1px solid ${dark ? color.signInInputBorder : color.border}`,
          color: dark ? color.signInHeading : color.text,
        }}
      >
        {codes.map((c) => (
          <li key={c}>{c}</li>
        ))}
      </ol>
      <Group gap={8}>
        <Button size="xs" variant="default" onClick={() => void copy()}>
          {copied ? 'Copied' : 'Copy'}
        </Button>
        <Button size="xs" variant="default" onClick={download}>
          Download
        </Button>
      </Group>
    </div>
  );
}
